/**
 * ProdutoCombinacaoLocalRepository
 *
 * Repositório frontend para combinações de produto no PDV Desktop.
 * Delega ao processo principal via Electron IPC (produtoCombinacoes namespace).
 */
import { getElectronAPI } from "@/plugins/desktop";

const ProdutoCombinacaoLocalRepository = {
  /**
   * Salva (upsert) uma lista de combinações de produto.
   * @param {Array} combinacoes
   */
  async salvarCombinacoes(combinacoes) {
    const api = getElectronAPI();
    return api.produtoCombinacoes.salvar(combinacoes);
  },

  /**
   * Busca todas as combinações de um produto.
   * @param {number} id_produto
   * @returns {Promise<Array>}
   */
  async buscarCombinacoesPorProduto(id_produto) {
    const api = getElectronAPI();
    return api.produtoCombinacoes.buscarPorProduto(id_produto);
  },

  /**
   * Busca uma combinação pelo seu id.
   * @param {number} id_produto_combinacao
   * @returns {Promise<Object|null>}
   */
  async buscarCombinacaoPorId(id_produto_combinacao) {
    const api = getElectronAPI();
    return api.produtoCombinacoes.buscarPorId(id_produto_combinacao);
  },

  /**
   * Retorna true se o produto possui ao menos uma combinação cadastrada.
   * @param {number} id_produto
   * @returns {Promise<boolean>}
   */
  async produtoPossuiCombinacoes(id_produto) {
    const api = getElectronAPI();
    return api.produtoCombinacoes.possuiCombinacoes(id_produto);
  },

  /**
   * Conta o total de combinações cadastradas.
   * @returns {Promise<number>}
   */
  async contarCombinacoes() {
    const api = getElectronAPI();
    return api.produtoCombinacoes.contar();
  },
};

/**
 * Gera uma descrição legível a partir do objeto ou array de combinação.
 * Ex: { cor: "Azul", tamanho: "M" }  → "Cor: Azul | Tamanho: M"
 * Ex: [{ nome: "Cor", valor: "Azul" }] → "Cor: Azul"
 * @param {Object|Array|string|null} combinacao
 * @returns {string}
 */
export function formatarDescricaoCombinacao(combinacao) {
  if (!combinacao) return "";
  let obj = combinacao;
  if (typeof combinacao === "string") {
    try { obj = JSON.parse(combinacao); } catch { return combinacao; }
  }
  if (Array.isArray(obj)) {
    return obj
      .map((item) => {
        const nome  = item.nome  ?? item.name  ?? item.chave ?? "";
        const valor = item.valor ?? item.value ?? "";
        return nome ? `${_capitalizar(nome)}: ${valor}` : String(valor);
      })
      .filter(Boolean)
      .join(" | ");
  }
  if (typeof obj === "object") {
    return Object.entries(obj)
      .map(([k, v]) => `${_capitalizar(String(k))}: ${v}`)
      .join(" | ");
  }
  return String(obj);
}

function _capitalizar(str) {
  if (!str) return "";
  return str.charAt(0).toUpperCase() + str.slice(1);
}

export default ProdutoCombinacaoLocalRepository;
